import React from 'react';
import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const ErrorPage = ({errorText}) => {
    if (!errorText) {
        return null;
    }

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px' }}>
      <Alert severity="error">
        <Typography variant="h6" component="h2">
          Something went wrong!
        </Typography>
        <Typography variant="body1">{errorText}</Typography>
      </Alert>
    </Container>
  );
};

export default ErrorPage;